import React from "react";

export default class StepperPaso2  extends React.Component { 

    render() {
        return <div className="flex layout-gt-md-row layout-md-row layout-xs-column layout-sm-column layout-align-center-center">
            <div id="stepper">
                <hr className="hr-poliza2" />
                <label id="label-poliza2">PÓLIZA</label>
            </div>

            <div id="stepper">
                <hr className="hr-contacto2" />
                <label id="label-contacto2">CONTACTO</label>
            </div>

            <div id="stepper">
                <hr className="hr-seguridad2" />
                <label id="label-seguridad2">SEGURIDAD</label>
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/stepper-gnp-registro/stepper-paso2.cmpt.js